// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jnLs","label":"styles_label__12X8E"};